import { Input } from 'ui/atoms/Input'
import { FormItem } from '@frontend/design_system'
import { APPLICATION_FORM_VALUES } from 'texts/applications'
import { FormItemChildren } from 'types/form'
import styles from './styles.module.scss'

export const ContactInformation = () => (
  <>
    <div className={styles['form-items-row']}>
      <FormItem
        id={APPLICATION_FORM_VALUES.NAME.ID}
        className={styles['form-item']}
      >
        {({ value, error, onChange }: FormItemChildren) => (
          <Input
            value={value}
            placeholder=""
            size="large"
            error={error}
            disabled
            spaceForError="none"
            onChange={onChange}
            label={APPLICATION_FORM_VALUES.NAME.LABEL}
          />
        )}
      </FormItem>
      <FormItem
        id={APPLICATION_FORM_VALUES.PERSON_NAME.ID}
        className={styles['form-item']}
      >
        {({ value, error, onChange }: FormItemChildren) => (
          <Input
            value={value}
            placeholder=""
            size="large"
            error={error}
            disabled
            spaceForError="none"
            onChange={onChange}
            label={APPLICATION_FORM_VALUES.PERSON_NAME.LABEL}
          />
        )}
      </FormItem>
    </div>
    <div className={styles['form-items-row']}>
      <FormItem
        id={APPLICATION_FORM_VALUES.EMAIL.ID}
        className={styles['form-item']}
      >
        {({ value, error, onChange }: FormItemChildren) => (
          <Input
            value={value}
            placeholder=""
            size="large"
            error={error}
            disabled
            spaceForError="none"
            onChange={onChange}
            label={APPLICATION_FORM_VALUES.EMAIL.LABEL}
          />
        )}
      </FormItem>
      <FormItem
        id={APPLICATION_FORM_VALUES.CURRENT_PHONE.ID}
        className={styles['form-item']}
      >
        {({ value, error, onChange }: FormItemChildren) => (
          <Input
            value={value}
            placeholder=""
            size="large"
            error={error}
            disabled
            spaceForError="none"
            onChange={onChange}
            label={APPLICATION_FORM_VALUES.CURRENT_PHONE.LABEL}
          />
        )}
      </FormItem>
    </div>
  </>
)
